import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  GetPerformanceScoreFixedList,
  GetPerformanceScoreFixedListSubmitted,
} from "../../Repository/Api";
import { Link } from "react-router-dom";
import { errorMsg } from "../Toastify";
import { FinancialYearViewIndex, Profileinfo } from "../Common/FinancialYear";

const StaffPerformance = () => {
  const { first_name, desingation, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const [tempReport, setTempReport] = useState({});
  const [savedReport, setSavedReport] = useState({});
  
  
  useEffect(() => {
    getTempReport();
    getSavedReport();
  },[]);

  const [active, setActive] = useState(0);
  const links = ["Pending", "Submitted"];
  const showSelected = (index) => {
    setActive(index);
  };

  const getTempReport = async () => {
    const response = await GetPerformanceScoreFixedList(token);
    if (response && response.statusCode === 200) {
      setTempReport(response?.data?.report);
    } else {
      errorMsg(response.message);
    }
  };
  const getSavedReport = async () => {
    const response = await GetPerformanceScoreFixedListSubmitted(token);
    if (response && response.statusCode === 200) {
      setSavedReport(response?.data?.report);
    } else {
      errorMsg(response.message);
    }
  };

  return (
    <>
      <div className="">
        <Profileinfo
          first_name={first_name}
          designation={desingation}
          department={department}
        />
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-12">
                    <h6 className="labeltitle">Performance Score Board Fixed</h6>
                  </div>
                  <div className="col-12">
                    <ul className="searchtopflex">
                      {links.map((link, index) => {
                        return (
                          <li
                            onClick={() => showSelected(index)}
                            key={link}
                            className={
                              active === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {link}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                {active === 0 && (
                  <>
                    <table className="table table-hover mt-4">
                      <thead>
                        <tr>
                          <th scope="col">Year</th>
                          <th scope="col">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tempReport?.length ? (
                          tempReport?.map(
                            (temp, index) => (
                              <tr>
                                <td>
                                  {temp?.academic_year
                                    ? FinancialYearViewIndex(temp?.academic_year)
                                    : "-"}
                                </td>
                                <td className="viewoption">
                                  <Link
                                    to={`/app/Staff/StaffPerformanceSpecificReport/${temp?.id}`}
                                  >
                                    View
                                  </Link>
                                </td>
                              </tr>
                            )
                          )
                        ) : (
                          <>
                            <tr>
                              <td className="text-center" colSpan={2}> No Data Found</td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </>
                )}
                {active === 1 && (
                  <table className="table table-hover mt-4">
                    <thead>
                      <tr>
                        <th scope="col">Year</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {savedReport?.length > 0 ? (
                        savedReport &&
                        savedReport?.map((saved, index) => (
                          <tr key={index}>
                            <td>
                              {saved?.academic_year
                                ? FinancialYearViewIndex(saved?.academic_year)
                                : "-"}
                            </td>
                            <td className="viewoption">
                              <Link
                                to={{
                                  pathname: `/app/Staff/StaffPerformanceSpecificViewReport/${saved?.id}`,
                                  state: 'submitted'
                                }}>
                                View
                              </Link>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <>
                          <tr>
                            <td className="text-center" colSpan={2}> No Data Found</td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default StaffPerformance;
